import { render, staticRenderFns } from "./depreCiationSituation.vue?vue&type=template&id=b1a4c490&scoped=true&"
import script from "./depreCiationSituation.vue?vue&type=script&lang=js&"
export * from "./depreCiationSituation.vue?vue&type=script&lang=js&"
import style0 from "./depreCiationSituation.vue?vue&type=style&index=0&id=b1a4c490&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a4c490",
  null
  
)

export default component.exports